import { useRoutes } from 'react-router-dom';
import Sidebar from "./Sidebar/Sidebar";
import Topbar from "./Topbar/Topbar";
import Footer from "./Footer/Footer";
import {useDispatch, useSelector} from "react-redux";
import classNames from "classnames";
import {hidedSidebar, hidingSidebar} from "../../store/actions/sidebar";

const Layout = ({sitemap}) => {
    const dispatch = useDispatch();
    const routes = useRoutes(sitemap);
    const sidebar = useSelector((state) => state.sidebar);
    const wrapperClassNames = {
        'wrapper': true,
        'reveal-side-navigation': true,
        'element-reveal-right': sidebar === 1,
        'inactive': sidebar !== 0,
        'slide-in': sidebar === 1
    }
    const handleTransitionEnd = (event) => {
        if (event.target.className !== 'wrapper reveal-side-navigation inactive') return false;
        document.body.classList.remove('aux-navigation-active');
        document.body.classList.remove('no-scroll');
        dispatch(hidedSidebar());
    };
    const handleClick = () => {
        if (sidebar !== 0)
            dispatch(hidingSidebar())
    }
    return (
        <>
            <Sidebar />
            <div className={classNames(wrapperClassNames)} onTransitionEnd={handleTransitionEnd} onClick={ handleClick }>
                <div className="wrapper-inner">
                    <Topbar />

                    <div className="content clearfix">
                        { routes }
                    </div>

                    <Footer />
                </div>
            </div>
        </>
    );
}

export default Layout;